module.exports = __webpack_public_path__ + "static/media/bg-pattern-cc.19a7ae75.png";